export enum HttpRequestStatus {
  NOOP = 'NOOP',
  ON_GOING = 'ON_GOING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}
